import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Dropdown } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import UsersTableComponent from "../../components/tables/UsersTableComponent";
import PageLayout from "../../layouts/PageLayout";
import floats from "../../assets/data/floats.json"
import users from "../../assets/data/users.json"
import {listadoUsuarios} from "../../api/usuarios.api.ts";
import { use } from "i18next";

export default function UserListPage() {

     const { t, n, currentLanguage } = useContext(TranslatorContext);
    const [userList, setUserList] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage] = useState(12);

    useEffect(() => {
        async function fetchUsers() {
            try {
                const response = await listadoUsuarios();
               
                    setUserList(response.usuarios);
                    setFilteredUsers(response.usuarios);
                    console.log("User List:", response.usuarios);
                
            } catch (error) {
                console.error("Error fetching user list:", error);
            }
        }
        fetchUsers();

    }, []);

    // Efecto para filtrar usuarios basado en el término de búsqueda
    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredUsers(userList);
        } else {
            const filtered = userList.filter(user => {
                const searchLower = searchTerm.toLowerCase();
                return (
                    user.usu_nombre?.toLowerCase().includes(searchLower) ||
                    user.usu_apellido?.toLowerCase().includes(searchLower) ||
                    user.usu_email?.toLowerCase().includes(searchLower) ||
                    user.usu_rut?.toString().includes(searchTerm) ||
                    user.usu_dv?.toLowerCase().includes(searchLower) ||
                    `${user.usu_rut}-${user.usu_dv}`.includes(searchTerm) ||
                    user.usu_fcreacion?.includes(searchTerm)
                );
            });
            setFilteredUsers(filtered);
        }
        // Resetear a la primera página cuando se filtra
        setCurrentPage(1);
    }, [searchTerm, userList]);

     // Lógica de paginación (ahora usa filteredUsers en lugar de userList)
    const totalUsers = filteredUsers.length;
    const totalPages = Math.ceil(totalUsers / usersPerPage);
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

    // Generar lista de páginas (puedes mejorar esto para mostrar ... dinámico)
    const pageNumbers = [];
    for (let i = 1; i <= Math.min(totalPages, 5); i++) {
        pageNumbers.push(i);
    }
    if (totalPages > 5) pageNumbers.push("...", totalPages);

    const handlePageClick = (page) => {
        if (typeof page === "number" && page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    // Función para actualizar la lista de usuarios desde el componente hijo
    const updateUserList = (newUserList) => {
        setUserList(newUserList);
        // La lista filtrada se actualizará automáticamente por el useEffect
        // Mantener la página actual si es válida, si no, ir a la primera página
        const filtered = searchTerm.trim() ? newUserList.filter(user => {
            const searchLower = searchTerm.toLowerCase();
            return (
                user.usu_nombre?.toLowerCase().includes(searchLower) ||
                user.usu_apellido?.toLowerCase().includes(searchLower) ||
                user.usu_email?.toLowerCase().includes(searchLower) ||
                user.usu_rut?.toString().includes(searchTerm) ||
                user.usu_dv?.toLowerCase().includes(searchLower) ||
                `${user.usu_rut}-${user.usu_dv}`.includes(searchTerm) ||
                user.usu_fcreacion?.includes(searchTerm)
            );
        }) : newUserList;
        
        const newTotalPages = Math.ceil(filtered.length / usersPerPage);
        if (currentPage > newTotalPages && newTotalPages > 0) {
            setCurrentPage(1);
        }
    };

    // Función para manejar el cambio en el campo de búsqueda
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Función para limpiar la búsqueda
    const clearSearch = () => {
        setSearchTerm("");
    };

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('user_list')}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item">Usuarios</li>
                                <li className="mc-breadcrumb-item">Listado de Usuarios</li>
                            </ul>
                        </div>
                    </div>
                </Col>
               
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">Usuarios Registrados</h4>
                            
                            {/* Campo de búsqueda */}
                            <div className="mc-card-search" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{ position: 'relative', maxWidth: '300px' }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar usuarios..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                        style={{ paddingRight: searchTerm ? '40px' : '10px' }}
                                    />
                                    {searchTerm && (
                                        <button
                                            type="button"
                                            onClick={clearSearch}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                border: 'none',
                                                background: 'none',
                                                cursor: 'pointer',
                                                color: '#666'
                                            }}
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                                {searchTerm && (
                                    <small style={{ color: '#666' }}>
                                        {totalUsers} resultado{totalUsers !== 1 ? 's' : ''} encontrado{totalUsers !== 1 ? 's' : ''}
                                    </small>
                                )}
                            </div>
                           
                        </div>
                        
                        <UsersTableComponent 
                            thead={ users.thead }
                            tbody={ currentUsers }
                            onUserUpdate={ updateUserList }
                        />
                       <div className="mc-paginate">
                            <p className="mc-paginate-title">
                                mostrando
                                <b> {n(currentUsers.length)} </b> 
                                de
                                <b> {n(totalUsers)} </b>
                                resultados
                            </p>
                            <ul className="mc-paginate-list">
                                <li className="mc-paginate-item" onClick={() => handlePageClick(currentPage - 1)}>
                                    { currentLanguage?.dir === "ltr" ? 
                                        <i className="material-icons">chevron_left</i> 
                                        : <i className="material-icons">chevron_right</i>
                                    }
                                </li>
                                {pageNumbers.map((num, idx) => (
                                    <li
                                        key={idx}
                                        className={`mc-paginate-item${num === currentPage ? " active" : ""}`}
                                        onClick={() => typeof num === "number" && handlePageClick(num)}
                                        style={{ cursor: typeof num === "number" ? "pointer" : "default" }}
                                    >
                                        {typeof num === "number" ? n(num) : num}
                                    </li>
                                ))}
                                <li className="mc-paginate-item" onClick={() => handlePageClick(currentPage + 1)}>
                                    { currentLanguage?.dir === "ltr" ? 
                                        <i className="material-icons">chevron_right</i> 
                                        : <i className="material-icons">chevron_left</i>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}